export enum Fraction {
  Half = 0.5,
  Whole = 1,
}
